import React from 'react';
// import blue from '../../assets/blue.jpg'
import './styles.css';

type HeroProps = {
  onNavigate: (href: string) => void;
};

function Hero({ onNavigate }: HeroProps) {
  return (
    <section className="hero">
      <div className="hero-text scroll-reveal">
        <p className="eyebrow">At FR Fisheries</p>
        <h1>
          We deliver fresh and responsibly sourced seafood with unmatched freshness and service —
          <span className="accent">Straight from the heart of Ocean.</span>
        </h1>
        <div className="hero-actions">
          <button
            className="btn"
            type="button"
            onClick={() => {
              onNavigate('/#contact');
            }}
          >
            Get started
          </button>
          <button
            onClick={() => {
              onNavigate('/#catalog');
            }}
            className="btn btn-outline"
            type="button"
          >
            View live catalog
          </button>
        </div>
        <div className="hero-metrics">
          <div>
            <strong>1,800+</strong>
            <span>boats onboarded</span>
          </div>
          <div>
            <strong>231</strong>
            <span>coastal hubs</span>
          </div>
          <div>
            <strong>97%</strong>
            <span>on-time deliveries</span>
          </div>
        </div>
      </div>
      {/*<div className="hero-card scroll-reveal" aria-label="Quality dashboard">
        <img src={blue} alt="" />
      </div>*/}
    </section>
  );
}

export default Hero;
